module.exports = __webpack_public_path__ + "img/hubungi-kami-w.c4709251.svg";